<template>
  <div class="px-4 sm:px-5 lg:px-5 mt-5 ">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-xl font-semibold text-gray-900">{{$t("fanpages.title")}}</h1>
          <p class="mt-2 text-sm text-gray-700">{{$t("fanpages.headline")}}</p>
        </div>
        <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
          <span v-if="facebookIntegrated">
            {{$t("fanpages.integrationSaved")}}
          </span>
          <button v-if="!userToken && !facebookIntegrated" v-on:click="scheduleFetchFanpages" type="button" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
            {{$t("fanpages.connectStart2")}}
          </button>
        </div>
      </div>
      <div class="mt-8 flex flex-col">
        <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="block py-2 align-middle md:px-6 lg:px-8">
            <div v-if="userToken && !facebookIntegrated" class="mb-12">
              <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                <table class="min-w-full divide-y divide-gray-300">
                  <thead class="bg-gray-50">
                    <tr>
                      <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">{{$t("fanpages.fanpage")}}</th>
                      <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{$t("fanpages.instagram")}}</th>
                      <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{$t("fanpages.id")}}</th>
                      <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                        <span class="sr-only">{{$t("fanpages.connect")}}</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200 bg-white">
                    <tr v-if="fetchFailed">
                      <td class="py-4 pl-4 pr-3 text-sm font-medium text-red-600" colspan="6">{{ $t('fanpages.fetchError')}}</td>
                    </tr>
                    <tr v-for="fanpage of fanpages" v-bind:key="fanpage.id">
                      <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                        {{fanpage.name}}
                        <div v-if="fanpage.error" class="text-red-700 text-sm font-bold mt-2">
                          {{fanpage.error}}
                        </div>
                      </td>
                      <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <span v-if="fanpage.hasInstagram && fanpage.instagramAccount">
                          <img class="h-12 w-12 rounded-full inline-block mr-3" :src="fanpage.instagramAccount.profile_picture_url">
                          {{fanpage.instagramAccount.name}}
                          <span class="text-red-600" v-if="fanpage.instagramBlocked">
                            {{$t("fanpages.igBlocked")}}
                          </span>
                        </span>
                        <span v-else>
                          -
                        </span>
                      </td>
                      <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{fanpage.id}}</td>
                      <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                        <input type="checkbox" v-model="selectedFanpages[fanpage.id]" checked="checked"  class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="showSave" class="text-right mt-5">
                <span v-if="error" class="text-red-700 text-sm font-bold mr-5">{{error}}</span>
                <button v-on:click="saveConnections" class="bg-indigo-600 hover:bg-indigo-800 text-white font-bold py-2 px-4 rounded text-sm">
                  {{$t("fanpages.saveConnections")}}
                </button>
              </div>
            </div>

            <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table class="min-w-full divide-y divide-gray-300">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">{{$t("fanpages.fanpage")}}</th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{$t("fanpages.instagram")}}</th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{$t("fanpages.id")}}</th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{$t("fanpages.lastUpdate")}}</th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{$t("fanpages.status")}}</th>
                    <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                      <span class="sr-only">Actions</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 bg-white">
                  <tr v-for="fanpage of fanpagesStore.collection" v-bind:key="fanpage.id">
                    <FanpageListItem v-bind:fanpage="fanpage" v-on:delete-event="getExistingFanpages" />
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import facebookIntegrationModel from '@/models/facebook-integration'
import facebookFanpageModel from '@/models/facebook-fanpage'
import FanpageListItem from '../fanpages/FanpageListItem'
import fbsdk from "../building_blocks/fbsdkMixin";

import { useFanpagesStore } from '@/stores/fanpages';


export default {
  name: 'FacebookPage',
  mixins: [fbsdk],
  components: { FanpageListItem },
  setup() {
    let fanpagesStore = useFanpagesStore();
    return {
      fanpagesStore,
    };
  },
  created() {
    this.loadFacebookSDK();
    this.getExistingFanpages();
  },
  methods: {
    scheduleFetchFanpages() {
      this.runAsFacebookUser(this.fetchFanpages);
    },
    fetchFanpages(authResponse) {
      this.userToken = authResponse.accessToken;
      this.userFbId = authResponse.userID;
      let self = this;
      window.FB.api('/me/accounts', function(response) {
       self.fanpages = response.data;
       if (!self.fanpages) {
         self.fetchFailed = true;
         return;
       }
       this.fetchFailed = false;
       self.fanpages.forEach(page => {
         page.hasInstagram = false;
         window.FB.api(`/me?fields=instagram_business_account&access_token=${page.access_token}`, function (res) {
           if (res.instagram_business_account) {
             page.hasInstagram = true;
             window.FB.api(`${res.instagram_business_account.id}?fields=profile_picture_url,name&access_token=${page.access_token}`, function(ig) {
               page.instagramAccount = ig;
             });
             window.FB.api(`/me/conversations?platform=instagram&access_token=${page.access_token}`, function(conversations) {
               if (!conversations || conversations.error) {
                 page.instagramBlocked = true;
               }
             });
           }
         });
         self.selectedFanpages[page.id] = true;
       });
     });
    },
    async saveConnections() {
      let integration = facebookIntegrationModel.buildCreate(this.userToken);
      let response;
      try {
        response = await facebookIntegrationModel.createIntegration(integration, this.axios, this.$root.token);
      } catch(error) {
        if (error.response) {
          if (error.response.data.errors[0].source.pointer === 'data/attributes/facebook_user_id') {
            this.error = 'This account is already used by another ChatPilot business.';
          }
        } else {
          this.error = 'Error saving Facebook integration.';
        }
      }
      if (response && response.status === 201) {
        await this.saveFanpages();
        if (!this.hasFanpageErrors) {
          this.selectedFanpages = {}
          this.userToken = undefined;
          this.userFbId = undefined;
          this.fanpages = [];
          this.facebookIntegrated = true;
        }
        await this.getExistingFanpages();
      } else {
        if (response) {
          this.error = 'Error saving Facebook integration.'
        }
      }
    },
    async saveFanpages() {
      this.hasFanpageErrors = false;
      for (const page of this.fanpages) {
        if (this.selectedFanpages[page.id]) {
          let integration = facebookFanpageModel.buildCreate(page.id, this.userFbId, page.hasInstagram);
          try {
            await facebookFanpageModel.createFanpage(integration, this.axios, this.$root.token);
          } catch(error) {
            this.hasFanpageErrors = true;
            if (error.response) {
              if (error.response.data.errors[0].source.pointer === 'data/attributes/fanpage_id') {
                if (error.response.data.errors[0].detail === 'lack-of-permissions') {
                  page.error = 'Lack of permissions to integrate fanpage with ChatPilot.io.'
                } else {
                  page.error = 'Fanpage already integrated with different ChatPilot business entity.'
                }
              }
            } else {
              page.error = 'Error saving fanpage data. Try again.';
            }
          }
        }
      }
    },
    async getExistingFanpages() {
      await facebookFanpageModel.getExistingFanpages(this.axios, this.fanpagesStore, this.$root.token);
    },
  },
  computed: {
    showSave() {
      return this.fanpages && this.fanpages.length > 0;
    },
  },
  data() {
    return {
      fanpages: [],
      selectedFanpages: {},
      userToken: undefined,
      userFbId: undefined,
      facebookIntegrated: false,
      error: '',
      hasFanpageErrors: false,
      fetchFailed: false,
    }
  },
}
</script>
